import type { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import MessageModal from '@wix/da-ds/pkg/modals/dsPresets/MessageModal';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import { URLS } from '@wix/da-url';

import s from './WithdrawalSuspendedModal.scss';

export interface Props {
  isOpen: boolean;
  requestClose: () => void;
}

const WithdrawalSuspendedModal: FC<Props> = ({ isOpen, requestClose }) => {
  const { t } = useTranslation();

  return (
    <MessageModal
      className={s['wrapper']}
      contentClassName={s['content']}
      variant="horizontal"
      title={t('studio.earnings.withdrawalSuspended.title')}
      message={
        <div className={s['description']}>
          <Trans i18nKey="studio.earnings.withdrawalSuspended.description">
            Please contact{' '}
            <a href={URLS.SUPPORT} className={s['underline']}>
              Customer Support
            </a>{' '}
            for more information about what might be preventing your withdrawal.
          </Trans>
        </div>
      }
      footerButtons={[
        <BrandedButton onClick={requestClose} size="large" variant="brand-green" key="okay">
          {t('common.gotIt')}
        </BrandedButton>,
      ]}
      onRequestClose={requestClose}
      shouldCloseOnOverlayClick
      isOpen={isOpen}
    />
  );
};

WithdrawalSuspendedModal.displayName = 'WithdrawalSuspendedModal';

export default WithdrawalSuspendedModal;
